export default __webpack_public_path__ + "navigation-examples-embedded-navigation-v1-960-64fb0f14acf1d283616855125392d595.webp";